module.exports = __webpack_public_path__ + "img/fauteuil-26.90fc67ff.jpg";